import { render } from "./AffiliatesPage.vue?vue&type=template&id=eff63976"
import script from "./AffiliatesPage.vue?vue&type=script&lang=js"
export * from "./AffiliatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__